/**
 * Map a detected frequency to the nearest just-intonation swara, relative to Sa.
 * Octave-aware and wrap-safe (a note just below Sa maps to S with a small negative
 * cents deviation, not to N in the octave below). See FR-4 / AC-4.2.
 */
import { JI_RATIOS, SWARA_SYMBOLS } from './music.js';
/** Ideal within-octave cents for each swara (S = 0). */
const SWARA_CENTS = SWARA_SYMBOLS.map((s) => ({
    symbol: s,
    cents: 1200 * Math.log2(JI_RATIOS[s]),
}));
function nearestFrom(freqHz, saHz, candidates) {
    const totalCents = 1200 * Math.log2(freqHz / saHz);
    let best;
    let bestAbs = Infinity;
    for (const { symbol, cents: ideal } of candidates) {
        // Pick the octave k whose ideal pitch is closest to the detected pitch.
        // `| 0` normalizes a possible -0 from Math.round to 0.
        const k = Math.round((totalCents - ideal) / 1200) | 0;
        const dev = totalCents - (ideal + 1200 * k);
        if (Math.abs(dev) < bestAbs) {
            bestAbs = Math.abs(dev);
            best = { symbol, octave: k, cents: dev };
        }
    }
    // candidates is always non-empty at call sites.
    return best;
}
/** Nearest of all 12 swaras. */
export function nearestSwara(freqHz, saHz) {
    return nearestFrom(freqHz, saHz, SWARA_CENTS);
}
/** Nearest swara restricted to a given set (e.g. a raga's allowed swaras). */
export function nearestSwaraAmong(freqHz, saHz, allowed) {
    const set = new Set(allowed);
    const candidates = SWARA_CENTS.filter((c) => set.has(c.symbol));
    if (candidates.length === 0)
        return null;
    return nearestFrom(freqHz, saHz, candidates);
}
//# sourceMappingURL=pitch.js.map